export class User {
  constructor(private readonly id: number, private readonly name: string, private readonly preferredName: string | null) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getPreferredName() {
    return this.preferredName;
  }
}
